import graphql from "babel-plugin-relay/macro";

const allNetworkOwnersDropdown = graphql`
    fragment NetworkOwnersFragments_AllNetworkOwnersDropdown on NetworkOwner @relay(plural: true) {
        id,
        name
    }
`
export default allNetworkOwnersDropdown